module.exports = __webpack_public_path__ + "static/media/AU.c6ec4035.svg";